import { Loading, Option, Select } from '@sede-enterprise/shell-ds-react-framework';
import FilePreview from './FilePreview';
import ModelTrainStatus from './ModelTrainStatus';
import useGetModelTrainResults from './hooks/useGetModelTrainResults';



const splitToArray = (id) => id.split("T");
const algoOptions = [{"label": "XGB", "value": "xgboost"}, {"label": "LGBM", "value": "lightgbm"}]

const ModelResults = (props) => {
    const { match } = props;

    const { csvData, csvHeaders, modelResults, loading } = useGetModelTrainResults(match.params.id);
    console.log("Model Results:", modelResults);
    const algoOption = algoOptions.find(option => option.value === modelResults?.model_type);

    return (
        <div className='parent-container' >
            <div className='content-container' >
                <div className='content-header' >
                    <h2>Model Train Details</h2>

                </div>
                <div className='content-body'>
                    {csvData.length > 0 && <FilePreview data={csvData} headers={csvHeaders} fileName={"Uploaded Data"} />}
                    <br />
                    <h4>Selected Parameters</h4>
                    {loading && <div className='loading-container'> <Loading /> </div>}
                    {!loading && modelResults && <div className='model-results-container'>
                        <div className='model-form-row-1'>
                            <div className='model-name'>
                                <div className='data-label'>Model Name</div>
                                <div className='data-value'>{modelResults.model_display_name.replaceAll('"', '')}</div>
                            </div>
                            <div className='selected-features'>
                                <div className='data-label'>Features</div>
                                <Select placeholder="Select Subject" mode='multiple' showSearch={true} value={modelResults.features.split(",")} allowClear={false}>
                                    {modelResults.features.split(",").map((feature, index) => <Option key={index} value={feature}>{feature}</Option>)}
                                </Select>
                            </div>
                            <div className='selected-algo'>
                                <div className='data-label'>Model Type</div>
                                <Select placeholder="Select Subject" showSearch={true} value={algoOption.value} allowClear={false}>
                                    <Option value={algoOption.value}>{algoOption.label}</Option>
                                </Select>
                            </div>
                            <div className='train-period'>
                                <div className='data-label'>Train Period</div>
                                <div className='data-value'>{splitToArray(modelResults.train_start)[0]} - {splitToArray(modelResults.train_end)[0]}</div>
                            </div>
                        </div>

                    </div>
                    }
                    <br />
                    <br />
                    <ModelTrainStatus match={match} />


                </div>
            </div>
        </div>
    )
}

export default ModelResults